'use client';

import Link, { LinkProps } from 'next/link';
import React, { PropsWithChildren, useImperativeHandle, useRef } from 'react';
import { useCurrentLocale } from 'next-i18n-router/client';
import { getUrlWithLocale } from '@stape-io/promo-shared-content/utils';

import i18nConfig from '@/lib/i18n/config';

export function I18nLink(
  { href, locale, children, ...props }: PropsWithChildren<Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps> & LinkProps>,
  ref?: React.Ref<HTMLAnchorElement>
) {
  const localRef = useRef<HTMLAnchorElement | null>(null);
  const currentLocale = useCurrentLocale(i18nConfig);
  const hrefLocale = locale || currentLocale;
  const currentHref = getUrlWithLocale(href.toString(), hrefLocale);

  useImperativeHandle(ref, () => localRef.current as HTMLAnchorElement);

  return (
    <Link href={currentHref} prefetch={false} {...props} ref={localRef}>
      {children}
    </Link>
  );
}
